import React, { Fragment } from "react";
import { displayPerformance, getPerformanceAndPrevious } from "./utilities";
import Print from "@hpo/client/utilities/print/Print";
import { ImpactTrackingSection } from "@hpo/client/models/Archive";
import smoothJoin from "@hpo/client/utilities/smoothJoin";

type ImpactTrackingProps = {
  payload: ImpactTrackingSection;
};

export function ImpactTracking(props: ImpactTrackingProps) {
  const { payload } = props;
  const { title, periods, tags } = payload;
  if (tags === null) return null;
  return (
    <Fragment>
      <h2>{title}</h2>
      {`Indicateurs d'impacts pour la période ${smoothJoin(periods)} et synthèse pour chaque appel à projet`}
      {tags.map((tag) => {
        return (
          <Fragment key={tag.id}>
            <h3>{tag.label}</h3>
            <table>
              <thead>
                <tr>
                  <th>Par structure et par projet</th>
                  {periods.map((p) => (
                    <th key={p}>{p}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tag.byIndicator.map((indicator) => {
                  const { id, label, project, organization, performances } =
                    indicator;
                  return (
                    <tr key={id}>
                      <td>
                        {label}
                        <br />
                        <small>
                          {organization.label} / {project.label}
                        </small>
                      </td>
                      {periods.map((p) => (
                        <td key={p}>
                          {displayPerformance(
                            getPerformanceAndPrevious(performances, p, periods),
                            tag.unit,
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th>{tag.label}</th>
                  {periods.map((p) => (
                    <th key={p}>
                      {displayPerformance(
                        getPerformanceAndPrevious(
                          tag.allIndicators,
                          p,
                          periods,
                        ),
                        tag.unit,
                      )}
                    </th>
                  ))}
                </tr>
              </tfoot>
            </table>
            <Print.Space size={0.5} />
            <table>
              <thead>
                <tr>
                  <th>Par appel à projet</th>
                  {periods.map((p) => (
                    <th key={p}>{p}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tag.byProgram.map((program) => {
                  const { id, label, performances } = program;
                  return (
                    <tr key={id}>
                      <td>{label}</td>
                      {periods.map((p) => (
                        <td key={p}>
                          {displayPerformance(
                            getPerformanceAndPrevious(performances, p, periods),
                            tag.unit,
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th>{tag.label}</th>
                  {periods.map((p) => (
                    <th key={p}>
                      {displayPerformance(
                        getPerformanceAndPrevious(tag.allPrograms, p, periods),
                        tag.unit,
                      )}
                    </th>
                  ))}
                </tr>
              </tfoot>
            </table>
          </Fragment>
        );
      })}
    </Fragment>
  );
}
